import React from "react";
import PropTypes from "prop-types";
import CheckboxButton from "./CheckboxButton";
import classnames from "classnames";

export default function ImageCheckbox({ label, checked, onChecked, src, ...restProps }) {
  const imageClasses = classnames("img-checkbox--image", {
    "img-checkbox--image-unchecked": !checked,
  });

  return (
    <div className="img-checkbox">
      <CheckboxButton
        role="checkbox"
        aria-checked={checked}
        onChecked={handleClick}
        checked={checked}
        {...restProps}
      />

      <img src={src} alt="" className={imageClasses} />
    </div>
  );

  function handleClick(newValue) {
    onChecked(newValue);
  }
}

ImageCheckbox.propTypes = {
  label: PropTypes.string,
  checked: PropTypes.bool,
  onChecked: PropTypes.func,
  src: PropTypes.string,
};
